import React from 'react';
import Translate from 'client/components/translate';
import classNames from 'classnames';
import { AiFillCheckCircle as IconCheckCircle } from 'react-icons/ai';

type Props = {
  password: string;
  className?: string;
};

type Requirement = {
  key: string;
  translatePath: string;
  test: (password: string) => boolean;
};

const requirements: Requirement[] = [
  {
    key: 'hasMinLength',
    translatePath: 'common.form.password.requirement.length',
    test: password => password.length >= 8,
  },
  {
    key: 'hasMixedCase',
    translatePath: 'common.form.password.requirement.mixedCase',
    test: password => /[a-z]/.test(password) && /[A-Z]/.test(password),
  },
  {
    key: 'hasNumber',
    translatePath: 'common.form.password.requirement.number',
    test: password => /\d/.test(password),
  },
  {
    key: 'hasSpecialChar',
    translatePath: 'common.form.password.requirement.special',
    test: password => /[~`!@#$%^&*()_\-+={[}\]|\\:;"'<,>.?/]/.test(password),
  },
];

export const isPasswordValid = (password: string) => requirements.every(req => req.test(password));

export const PasswordRequirements = ({ password, className }: Props) => (
  <div className={classNames('password-requirements', className)}>
    <div className="password-requirements__header">
      <Translate path="common.form.password.requirementsTitle" />
    </div>
    <ul className="password-requirements__list">
      {requirements.map((requirement) => {
        const isValid = requirement.test(password);
        return (
          <li
            key={requirement.key}
            className={classNames('password-requirements__item', {
              'password-requirements__item--valid': isValid,
              'password-requirements__item--invalid': !isValid,
            })}>
            <span className="password-requirements__indicator">
              {isValid ? <IconCheckCircle /> : <IconCheckCircle />}
            </span>
            <Translate path={requirement.translatePath} />
          </li>
        );
      })}
    </ul>
  </div>
);

PasswordRequirements.defaultProps = {
  className: undefined,
};
